"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sideBySideConfig = exports.createSideBySideColumnNode = void 0;
var react_1 = __importDefault(require("react"));
var SideBySide_1 = require("@CommonFrontend/ContentTokens/Models/SideBySide");
var slate_1 = require("slate");
var Paragraph_1 = require("./Paragraph");
var SideBySideWidget_1 = __importDefault(require("Project/QwilrEditor/Widgets/SideBySideWidget/SideBySideWidget"));
var MakeConfig_1 = require("../Utils/MakeConfig");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var Utils_1 = require("Project/QwilrEditor/Utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var TokenizationErrorRecorder_1 = require("Project/QwilrEditor/Tokenization/TokenizationErrorRecorder");
var createSideBySideColumnNode = function () { return ({
    type: "sideBySideColumn",
    children: [(0, Paragraph_1.createParagraphNode)()],
    isVoid: false,
}); };
exports.createSideBySideColumnNode = createSideBySideColumnNode;
var createSideBySideNode = function () { return ({
    type: "sideBySide",
    children: [(0, exports.createSideBySideColumnNode)(), (0, exports.createSideBySideColumnNode)()],
    isVoid: false,
    data: {
        percent: SideBySide_1.SideBySideColumnSize.OneHalf,
        placeholderIndex: SideBySide_1.SideBySidePlaceholderIndex.Column2,
    },
}); };
exports.sideBySideConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("sideBySide")), { node: {}, nodeType: "layoutElement", editorRender: SideBySideWidget_1.default, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        var e_1, _a;
        var _b;
        var nodeHasKey = function (node) {
            return !!node.key;
        };
        var getPath = function (key, value) {
            for (var i = 0; i < value.length; i++) {
                var node = value[i];
                if (nodeHasKey(node) && node.key == key) {
                    return [i];
                }
                if ("children" in node && node.children.length > 0) {
                    var maybePath = getPath(key, node.children);
                    if (maybePath) {
                        return [i].concat(maybePath);
                    }
                }
            }
            return null;
        };
        var getPlaceholderIndex = function (order, renderPlaceholder, placeholderIndex) {
            if (!order) {
                return placeholderIndex;
            }
            if (!renderPlaceholder) {
                return null;
            }
            return order === SideBySide_1.SideBySideOrder.Normal ? SideBySide_1.SideBySidePlaceholderIndex.Column2 : SideBySide_1.SideBySidePlaceholderIndex.Column1;
        };
        var placeholderIndex = getPlaceholderIndex(token.order, token.renderPlaceholder, token.placeholderIndex);
        var sideBySideNode = {
            type: "sideBySide",
            isVoid: false,
            data: {
                percent: token.percent,
                placeholderIndex: placeholderIndex,
            },
            children: [],
        };
        var columnNum = -1;
        var columns = ((_b = token.order) !== null && _b !== void 0 ? _b : SideBySide_1.SideBySideOrder.Normal) === SideBySide_1.SideBySideOrder.Normal
            ? [token.column1, token.column2]
            : [token.column2, token.column1];
        try {
            for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                var column = columns_1_1.value;
                columnNum++;
                var columnContent = void 0;
                if (column && column.length === 0) {
                    (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("sideBySide", columnNum === 1 ? "sideBySideColumn1" : "sideBySideColumn2", "deserialisation");
                    columnContent = { children: [(0, Paragraph_1.createParagraphNode)()] };
                }
                else {
                    columnContent = (0, Deserialise_1.deserialiseNode)(column, commentTracker);
                }
                var columnNode = {
                    type: "sideBySideColumn",
                    isVoid: false,
                    children: columnContent.children,
                };
                sideBySideNode.children.push(columnNode);
                if (columnContent.selection) {
                    sideBySideNode.key = "tempSideBySideKey";
                    var sideBySidePath = getPath(sideBySideNode.key, content.children.concat(sideBySideNode));
                    if (columnContent.selection.anchor.path) {
                        columnContent.selection.anchor.path = sideBySidePath.concat([columnNum], columnContent.selection.anchor.path);
                    }
                    if (columnContent.selection.focus.path) {
                        columnContent.selection.focus.path = sideBySidePath.concat([columnNum], columnContent.selection.focus.path);
                    }
                    if (content.selection) {
                        if (content.selection.anchor.path) {
                            content.selection.focus = columnContent.selection.focus;
                        }
                        else {
                            content.selection.anchor = columnContent.selection.anchor;
                        }
                    }
                    else {
                        content.selection = columnContent.selection;
                    }
                    delete sideBySideNode.key;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return sideBySideNode;
    }, serialise: function (block, editor, commentTracker, selection) {
        var _a, _b;
        var newToken = {
            type: "block",
            subType: "sideBySide",
            percent: block.data.percent || 50,
            placeholderIndex: block.data.placeholderIndex || null,
            column1: null,
            column2: null,
        };
        var children = block.children;
        newToken.column1 = (0, Serialise_1.mergeText)((0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection));
        if (((_a = newToken.column1) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("sideBySide", "sideBySideColumn1", "serialisation");
        }
        newToken.column2 = (0, Serialise_1.mergeText)((0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection));
        if (((_b = newToken.column2) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("sideBySide", "sideBySideColumn2", "serialisation");
        }
        var sideBySideTokens = [newToken];
        return sideBySideTokens;
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var widget = createSideBySideNode();
        var currentSelection = editor.selection;
        if (!slate_1.Range.isRange(currentSelection)) {
            return;
        }
        var currBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(currentSelection).path);
        if (!currBlockEntry) {
            return;
        }
        slate_1.Editor.withoutNormalizing(editor, function () {
            slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
            slate_1.Transforms.insertNodes(editor, widget, { at: currBlockEntry[1] });
        });
    }, validContainers: ["contentLoopBody"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        var SIDE_BY_SIDE_NUM_CHILDREN = 2;
        var replaceChildWithSideBySideColAtIndex = function (editor, path, index) {
            slate_1.Editor.withoutNormalizing(editor, function () {
                slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
                slate_1.Transforms.insertNodes(editor, (0, exports.createSideBySideColumnNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
            });
        };
        if (node.children.length === SIDE_BY_SIDE_NUM_CHILDREN) {
            if (node.children[0].type !== "sideBySideColumn") {
                replaceChildWithSideBySideColAtIndex(editor, path, 1);
                return true;
            }
            if (node.children[1].type !== "sideBySideColumn") {
                replaceChildWithSideBySideColAtIndex(editor, path, 2);
                return true;
            }
        }
        if (node.children.length < SIDE_BY_SIDE_NUM_CHILDREN) {
            slate_1.Transforms.insertNodes(editor, (0, exports.createSideBySideColumnNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        if (node.children.length > SIDE_BY_SIDE_NUM_CHILDREN) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetTwoColumns, null),
        tags: ["2 columns", "two columns", "columns", "sidebyside", "side by side", "2columns", "twocolumns"],
        displayName: "2 Columns",
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.SideBySide, containerNodeConfiguration: {
        showWidgetAdder: false,
        hasContainerManagedChildren: true,
    } }));
